<template>
  <h4>{{ Homebar }}</h4>
</template>

<script>
import {
  BASE_API_URL,
  ENV_CHECK,
  PROX_URL,
  NETBAY_URL,
  NETBAY_User,
  NETBAY_Password,
  NETBAY_Companycode,
  CUSTOMS_AUTH,
  CUSTOMS_GRANT_TYPE,
  CUSTOMS_CLIENT_ID,
  CUSTOMS_CLIENT_SECRET,
  CUSTOMS_CLIENT_SCOPE,
} from "@/constants/index.ts";
import axios from "axios";

export default {
  data() {
    return {
      Homebar: "HOME",
    };
  },
  watch: {
    // Homechanged() {
    //   this.Homebar = this.$store.state.Homebar;
    // }
  },
  computed: {
    // Homechanged(){
    //   return this.$store.state.Homebar;
    // }
  },
  methods: {
    async netLogin() {
      try {
        const formData2 = {
          username: NETBAY_User,
          password: NETBAY_Password,
          companyCode: NETBAY_Companycode,
        };

        const response2 = await axios.post(
          PROX_URL + NETBAY_URL + `fz-webservice/api/auth`,
          // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/auth`,
          // `https://uataotdc.netbay.co.th/fz-webservice/api/auth`,
          // `/api/fz-webservice/api/auth`,
          formData2,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // console.log(response2.data.data);
        if (response2.data) {
          localStorage.setItem("NETBAY_TOKEN", response2.data.data);
        }
      } catch (error) {
        // alert("กรุณาเข้าระบบอีกครั้ง");
        if (error.response) {
          // console.log(error.response.data);
          // console.log(error.response.data.message);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: error.response.data.message,
          });
        }
      }
    },
    async customsLogin() {
      try {
        const formData2 = new URLSearchParams();
        formData2.append('grant_type', CUSTOMS_GRANT_TYPE);
        formData2.append('client_id', CUSTOMS_CLIENT_ID);
        formData2.append('client_secret', CUSTOMS_CLIENT_SECRET);
        formData2.append('scope', CUSTOMS_CLIENT_SCOPE);

        // const formData2 = {
        //   grant_type: CUSTOMS_GRANT_TYPE,
        //   client_id: CUSTOMS_CLIENT_ID,
        //   client_secret: CUSTOMS_CLIENT_SECRET,
        //   scope: CUSTOMS_CLIENT_SCOPE,
        // };

        const response2 = await axios.post(
          CUSTOMS_AUTH + `oauth2/token`,
          // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/auth`,
          // `https://uataotdc.netbay.co.th/fz-webservice/api/auth`,
          // `/api/fz-webservice/api/auth`,
          formData2,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        // console.log(response2.data.access_token);
        if (response2.data.access_token) {
          localStorage.setItem("CUSTOMS_TOKEN", response2.data.access_token);
        }
      } catch (error) {
        // alert("กรุณาเข้าระบบอีกครั้ง");
        if (error.response) {
          // console.log(error.response.data);
          // console.log(error.response.data.message);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error From Customs",
            text: error.response.data.error,
          });
        }
      }
    },
    async customsLoginNew() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        if (token) {
          const formData = {
            searchval: "",
          };

          const response = await axios.post(
            `${BASE_API_URL}/queue-svc/jqueue/getCustomsKey`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status == 'error') {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              // color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            localStorage.setItem("CUSTOMS_TOKEN", response.data.message);
          }
        }
      } catch (error) {
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;
          this.email = decoded.email;
          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;

          this.Homebar = "Welcome " + decoded.email;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  beforeCreate() {
    localStorage.removeItem("NETBAY_TOKEN");
    localStorage.removeItem("CUSTOMS_TOKEN");
    localStorage.removeItem("TG_TOKEN");
  },
  async created() {
    // console.log(ENV_CHECK);
    if (ENV_CHECK == "PROD") {
      // this.netLogin();
      // this.customsLogin();
      this.customsLoginNew();

    }
  },
  mounted() {
    // console.log('home')
    const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
    // console.log(token.userRole);
    // setTimeout(() => {
    this.checkProfiles();

    let userRole = token.userRole;
    this.$store.dispatch("setuserRole", userRole);
    this.$acl.change(userRole);
    // }, 300);

    // setTimeout(() => {
    //     console.log(userRole);
    // }, 300);
  },
};
</script>
